import React from 'react';
import { getCredentialingPanelSummary } from 'api/credentialing';
import type { TPanelStatusSummary } from 'types/credentialing';

const INIT: TPanelStatusSummary = { actionNeeded: 0, inProgress: 0, approved: 0, live: 0 };
let globalData: TPanelStatusSummary = INIT;

const usePanelSummary = (): [TPanelStatusSummary, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TPanelStatusSummary>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getCredentialingPanelSummary();
            if (!result.error) {
                const summary: TPanelStatusSummary = result?.data?.data || INIT;
                globalData = summary;
                setData(summary);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default usePanelSummary;
